import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    'Missing Supabase env: set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY (e.g. in .env.local). ' +
    'Get the anon key from Supabase Dashboard → Project Settings → API → anon public.'
  )
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey)
